import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import React, { useState } from 'react';
import { ExtendedRadioGroup } from 'framework/components/ExtendedRadioGroup';
import { IInventoryItem } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';

interface IProps extends DialogProps {
	item: IInventoryItem;
	cancel: VoidFunction;
	confirm: (isForPatient: boolean) => void;
}

export const LinkToPatientForm = ({ item, cancel, confirm, ...rest }: IProps) => {
	const strings = useLocalization();
	const [isForPatient, setIsForPatient] = useState<boolean>(true);

	return (
		<Dialog
			fullWidth
			maxWidth='sm'
			{...rest}>
			<DialogTitle>{`${strings.repair}, ${strings.makeAChoice}`}</DialogTitle>
			<DialogContent dividers>
				<ExtendedRadioGroup<boolean>
					selected={isForPatient}
					setSelected={setIsForPatient}
					options={[
						{ value: true, label: strings.forPatient, caption: strings.forWho(item.patientIdentifier ?? '') },
						{ value: false, label: strings.notForPatient, caption: strings.bulkRepair },
					]}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={cancel}
					color='primary'>
					{strings.cancel}
				</Button>
				<Button
					onClick={() => confirm(isForPatient)}
					color='primary'>
					{strings.select}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
